import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * Whether the List Item is selected.
  */
  selected: PropTypes.bool
};
var ListItem = createComponent({
  displayName: 'ListItem',
  root: 'li',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      return props.selected ? ['swan-list-item-selected'] : [];
    }
  }
});
export { ListItem };